'use strict'

import {createStore, applyMiddleware, compose as reduxCompose} from 'redux'

import Config from '../lib/config'
import tokenRefresh from './middleware/token-refresh'
import thunk from 'redux-thunk'
import createReducer from './reducers/index'

const filterReducer = (reducers) => reducers

export default function (filterReducers = filterReducer, customMiddleware = [], debugReduxName = 'redux'){
	let middleware = [thunk, tokenRefresh, ...customMiddleware]
	let enhancer = []
	let compose = reduxCompose

	if(__DEV__){

		// Toggle this on when required, as this can slow down the application and cause warning when not connected
		if(Config.ENABLE_REDUX_TOOLS){
			const extraConfig = {}

			if(window.navigator.product == 'ReactNative'){
				extraConfig['hostname'] = Config.REDUX_TOOLS_HOST || '127.0.0.1'
				extraConfig['port'] = 5678
			}

			compose = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || require('remote-redux-devtools').composeWithDevTools)({
				name: debugReduxName,
				realtime: true,
				actionCreators: {
					...require('./actions/auth'),
					...require('./actions/balances'),
					...require('./actions/budgeting'),
					...require('./actions/payment'),
					...require('./actions/home'),
					...require('./actions/loading'),
					...require('./actions/messaging'),
					...require('./actions/nav-draw'),
					...require('./actions/notify'),
					...require('./actions/preferences'),
					...require('./actions/history'),
					...require('./actions/features'),
					...require('./actions/router')
				},
				...extraConfig
			})
		}
	}

	enhancer.unshift(applyMiddleware(...middleware))
	const store = createStore(createReducer(filterReducer), undefined, compose(...enhancer))

	if(module.hot){
		module.hot.accept(() => {
			const newCreateReducer = require('./reducers/index').default
			store.replaceReducer(newCreateReducer(filterReducers))
		})
	}

	return store
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/createStore.js